/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcLaptopIcon24Solid = forwardRef('TechPcLaptopIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7 3a4 4 0 0 0-4 4v5a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H7Z" }),
        React.createElement("path", { d: "M4.487 17.676a1 1 0 1 0-1.474-1.352L1.799 17.65C.623 18.93 1.533 21 3.273 21h17.454c1.74 0 2.65-2.069 1.474-3.351l-1.214-1.325a1 1 0 0 0-1.474 1.352L20.727 19H3.273l1.214-1.324Z" })));
});
